import React, { Component } from 'react';

export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer',

      
      
    },
    {
      name: "Jobs",
      url: "/dashboard/jobs",
      icon: "fa fa-check-square-o"
    },
    {
      name: "Administration",
      icon: "fa fa-cogs",                  
      children: [
        {
          icon: "fa fa-users",
          name: "Users",
          url: "/dashboard/users"
        },
        {
          icon: "fa fa-sitemap",
          name: "Clients",
          url: "/dashboard/clients",
          /*
          badge: {
            variant: 'danger',
            text:  5,
            pill: true
          } 
          */  
        },
        {
          icon: "fa fa-bar-chart",
          name: "Capacity",
          url: "/dashboard/capacity"
        },
        {
          icon: "fa fa-sliders",
          name: "Settings",
          url: "/dashboard/settings"
        }
      ]
    },
    {
      name: "Rate Management",
      icon: "fa fa-usd",
      children: [
        {
          name: "Base Rates",
          url: "/dashboard/base-rates",
          icon: "fa fa-line-chart"
        },
        {
          name: "Accessorials & Fees",
          url: "/dashboard/accessorials",
          icon: "fa fa-shopping-cart"
        }
      ]
    }
  ]
};

export const clientLinks = {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer',
      /*
      badge: {
        variant: 'info',
        text: 'NEW'
      }
      */
    },
    {
      name: "Jobs",
      url: "/dashboard/jobs",
      icon: "fa fa-check-square-o"
    },
    {
      name: "Administration",
      icon: "fa fa-cogs",
      children: [
        {
          icon: "fa fa-users",
          name: "Users",
          url: "/dashboard/users"
        }
      ]
    }
  ]
};


export const guestLinks = {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer',
    },
    {
      name: "Jobs",
      url: "/dashboard/jobs",
      icon: "fa fa-check-square-o"
    }
  ]
};



// WEBPACK FOOTER //
// ./src/components/Sidebar/_nav.js